import { render } from "./App.vue?vue&type=template&id=137599c8&scoped=true"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=137599c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-137599c8"],['__file',"src/cliente-embedded/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "137599c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('137599c8', __exports__)) {
    api.reload('137599c8', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=137599c8&scoped=true", () => {
    api.rerender('137599c8', render)
  })

}


export default __exports__